<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Table border :columns="listColumns" :data="newsList">
              <template slot-scope="{ row }" slot="title">
                <strong>{{ row.title }}</strong>
              </template>
              <template slot-scope="{ row }" slot="status">
                <Badge :text="row.status==1?'已通过':'待审核'" :class-name="row.status==1?'news-status-ok':''"></Badge>
              </template>
              <template slot-scope="{ row }" slot="action">
                <ButtonGroup>
                  <Button v-if="row.status==1" type="info" size="small" @click="newsView(row)">查看</Button>
                  <Button v-else-if="row.status!=1" type="info" size="small" disabled @click="newsView(row)">查看</Button>
                  <Button type="primary" size="small" @click="newsEdit(row)">编辑</Button>
                  <!-- <Button type="warning" size="small" @click="newsCheck(row)">审核</Button> -->
                  <Button type="error" size="small" @click="newsRemoveNotice(row)">删除</Button>
                </ButtonGroup>
              </template>
            </Table>
            <div class="admin-list-pager">
              <Page :total="newsNum" show-elevator show-total @on-change="pageChaged" />
            </div>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
    <Modal v-model="showMmoda" width="360">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>该内容删除后不能恢复。</p>
        <p>您确认要删除吗?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long  @click="newsRemove">删除</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  data () {
    return {
      showMmoda: false,
      deleteNews: {},
      token: '',
      newsNum: 0,
      newsList: [],
      page: 1,
      listColumns: [
        {
          title: '标题',
          slot: 'title'
        },
        {
          title: '最近更新',
          key: 'senddate',
          width: 150,
        },
        {
          title: '所属机构',
          key: 'assoName',
          width: 220,
        },
        {
          title: '作者',
          key: 'author',
          width: 120,
        },
        {
          title: '状态',
          slot: 'status',
          width: 100,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 190,
          align: 'center'
        }
      ],
    }
  },

  //页面加载完成后执行
  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取学生信息
    this.getNewsList()
  },

  //页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //从服务端获取文字列表
    getNewsList() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/news/list-for-manage",
        {page: vm.page, status: [0,1]},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.newsList = info.data.list
        vm.newsNum = info.data.num
      }).catch(function(error) {
        console.log(error)
      });
    },

    //内容查看
    newsView(item) {
      //console.log(item)
      window.open(this.$router.resolve({ path: '/news/show', query:{id: item.newsId , sid: item.assoId}}).href)
    },

    //内容编辑
    newsEdit(item)  {
      //console.log(item)
      window.open(this.$router.resolve({ path: '/manage/news/edit/'+item.newsId }).href)
    },

    //内容审核
    newsCheck(item)  {
      console.log(item)
    },

    //删除提示
    newsRemoveNotice(item) {
      this.deleteNews = item
      this.showMmoda = true
    },

    //内容删除
    newsRemove()  {
      let newsId = this.deleteNews.newsId
      let status = -1
      if(!isNaN(status) && status==-1) {
        let vm = this
        axios.post(
          vm.GLOBAL_API.apiUrl + "/manage/news/save-for-check",
          {id: newsId, status: status},
          {
            headers: {
              'content-type': 'application/json',
              "Authorization": "Bearer " + vm.token
            }
          }
        ).then(function(res) {
          let info = res.data
          let error = parseInt(info.code)
          if(!isNaN(error) && error==0) {
            vm.getNewsList()
            vm.showMmoda = false
            vm.deleteNews = {}
          }
        }).catch(function(error) {
          console.log(error)
        });
      }
    },

    //分页
    pageChaged(page) {
      this.page = page
      this.getNewsList()
    }
  }
}
</script>